<template>
  <div class="view-details" :class="{ 'dept-details': true, show: show }">
    <div class="flex flex-v-center flex-h-bet">
      <h3 class="bold blue">LEAVE DETAILS</h3>
      <img
        src="/img/circle-x.svg"
        alt="close"
        class="pointer"
        @click="$emit('toggleView')"
      />
    </div>
    <div class="view-details-body mt-20">
      <h3 class="bold">ID NO</h3>
      <div class="view-details-item">
        <p>{{ leaveData.id }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">EMPLOYEE NAME</h3>
      <div class="view-details-item">
        <p>{{ leaveData.employee_name }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">LEAVE TYPE</h3>
      <div class="view-details-item">
        <p>{{ leaveData.leave_type_name }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">START DATE</h3>
      <div class="view-details-item">
        <p>{{ dateFormatter(leaveData.start_date) }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">END DATE</h3>
      <div class="view-details-item">
        <p>{{ dateFormatter(leaveData.end_date) }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">RELIEF</h3>
      <div class="view-details-item">
        <p>{{ leaveData.relief }}</p>
      </div>
      <hr class="hr" />
      <template
        v-if="leaveData.status === 'rejected' && leaveData.rejection_reason"
      >
        <h3 class="bold mt-5">REJECTION REASON</h3>
        <div class="view-details-item">
          <p>{{ leaveData.rejection_reason }}</p>
        </div>
        <hr class="hr" />
      </template>
      <template
        v-if="leaveData.status === 'cancelled' && leaveData.cancellation_reason"
      >
        <h3 class="bold mt-5">CANCELLATION REASON</h3>
        <div class="view-details-item">
          <p>{{ leaveData.cancellation_reason }}</p>
        </div>
        <hr class="hr" />
      </template>
      <h3 class="bold mt-5">DATE CREATED</h3>
      <div class="view-details-item">
        <p>{{ dateFormatter(leaveData.created_at) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { dateFormatter } from "@/helpers/functions";

const { mapState } = createNamespacedHelpers("admin/hrm/leave");

export default {
  props: ["show"],
  computed: {
    ...mapState({
      view: "showViewContainer",
      loading: "viewContainerLoading",
      leaveData: "currentLeave",
    }),
  },
  methods: {
    dateFormatter,
  },
};
</script>

<style>
.hr {
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-top: 10px;
}

.mt-5 {
  margin-top: 5px;
}
</style>
